import { z } from "zod";
import type { ImageBgRemoveProvider, PipelineNode, PipelineSpec, ToolCore } from "@loumy/contracts";
import { CAP } from "@loumy/capabilities";

// §10 BG-Remove (D146) — eigenständiges Einzelbild-Tool: AI-Matting via **Bria RMBG 2.0** (fal),
// KEIN Greenscreen nötig. Bild rein → transparentes PNG raus. KEINE Generate-Phase → startet
// direkt in der Server-Post-Process-Phase (wie der Bild-Pfad des chroma-key-removers, nur
// AI-Matting statt chroma-key). Der Provider wird im Build gepinnt (Build==Laufzeit, D34).
//
// Abgrenzung: das chroma-key-remover-Tool deckt VIDEO-bg-remove (chroma gratis / BEN2 AI) ab;
// dieses Tool ist die Einzelbild-AI-Matting-Variante (User: „Bria … als eigenes Tool erstmal").

export const BgRemoveSettings = z.object({}).strict();
export type BgRemoveSettings = z.infer<typeof BgRemoveSettings>;

export const bgRemoveCore: ToolCore<BgRemoveSettings> = {
  id: "bg-remove",
  category: "image",
  inputs: [{ kind: "image", min: 1, max: 1, role: "source" }],
  settingsSchema: BgRemoveSettings,
  outputSlots: [{ name: "image", kind: "image", optional: false }],
  buildPipeline(_settings, _inputs, ctx): PipelineSpec {
    // D34: Provider gepinnt — der Default-Adapter des image-bg-remove-Slots (Bria RMBG 2.0).
    const bria = ctx.providers.resolve<ImageBgRemoveProvider>("image-bg-remove");
    const nodes: PipelineNode[] = [
      {
        id: "bg",
        capabilityId: CAP.imageBgRemove.id,
        capabilityVersion: CAP.imageBgRemove.version,
        surface: "server",
        inputs: { image: { node: "$input", port: "source" } },
        params: { providerId: bria.id, providerVersion: bria.version },
      },
    ];
    return { nodes, outputs: { image: { ref: { node: "bg", port: "image" } } } };
  },
};
